import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSend = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSend",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M176-183q-20 8-38-3t-18-34v-180l320-80-320-80v-180q0-22 18-33t38-4l616 260q25 11 25 37t-25 37z"
  })
}));
IconSend.displayName = 'IconSend';